import { css } from '@emotion/css';

export const articleViewer = css`
  width: 100%;
  & > div {
    margin: 0 auto;
  }

  [data-id='main-content'] {
    .editor-container {
      & > div {
        transform: scale(0.8);
        transform-origin: top;
      }
      & > div > *:first-child {
        margin-top: 3.2rem;
      }
    }
  }
`;
